import { Row, Col, Container, Card, Button, Table, Dropdown, Modal, Spinner, FormGroup, Form } from "react-bootstrap";
import Layout from "../../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Paginator from "../../components/table/Paginator";
import { useEffect, useRef, useState } from "react";
import receipt_avatar from '../../assets/images/receipt.svg';
import { useDispatch, useSelector } from "react-redux";
import formatCurrency from "../../utils/currencyFormmter";
import Logo from "../../components/Logo";
import dateFormatter from "../../utils/dateFormatter";
import RecordFilter from "../../components/RecordFilter";
import { toPng } from "html-to-image";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import shortenText from "../../utils/shortenText";
import { getMemberSalesforceTransactions, getSalesforceTransactions, withdrawSalesforceBalance } from "../../redux/slices/account.service";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import TransactionChart from "../../components/TransactionChart";


const SalesforceTransactionsHistory = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const receiptRef = useRef();

  const stopPropagation = (e) => e.stopPropagation();
  const isLoaded = useRef(false)
  const { user = {} } = useSelector((state) => state.auth)

  const [activeTab, setActiveTab] = useState('all')
  const [salesforce, setSalesforce] = useState({})
  const [transactions, setTransactions] = useState([])
  const [results, setResults] = useState([])
  const [analytics, setAnalytics] = useState({})
  const [receipt, setReceipt] = useState({})
  const [show_receipt, setShowReceipt] = useState(false)
  const [paginationData, setpaginationData] = useState({next: '', prev: ''})
  const [payload, setPayload] = useState({
      page: 1,
      from_date: '',
      to_date: '',
      status: '',
      download: '',
      filter_by: '',
      sort_by: '',
      filter: ''
  })
  const [loading, setLoading] = useState(false)
  const [withdrawal, setWithdrawal] = useState(false)
  const [showChart, setShowChart] = useState(false)
    
  useEffect(() => {
      if(!isLoaded.current) {
          loadTransactions()
          isLoaded.current = true
      }
  }, [0, payload.page])

  const selectTransaction = (id) => {
      const transaction = transactions.filter(item => item.reference === id)[0]
      setReceipt(transaction);
      setShowReceipt(true)
  }

  const loadTransactions = (download = false) =>  {
      let requestPayload = payload
      if(download) {
          requestPayload.download = 'True'
      }
      const action = user?.user_type === 'owner' ? getSalesforceTransactions : getMemberSalesforceTransactions
      setLoading(true)
      dispatch(action(requestPayload))
      .then((response) => {
          setPayload((prevState) => ({...prevState, download: ''}))
          if(response.payload.results) {
              setTransactions(response.payload.results)
              setTimeout(() => {
                  filterTransactions(response.payload.results, 'all')
              }, 1000);
          }
          if(response.payload?.analytics) {
              setAnalytics(response.payload.analytics)
          }

          if(response.payload?.next || response.payload?.previous) {
              const data = {
                  next: response.payload?.next,
                  prev: response.payload?.previous,
              }
              setpaginationData(data)
          }
      })
      .finally(() => setLoading(false))
  }

  const filterTransactions  = (payload = transactions, value) => {

      if(value.toLowerCase().includes('voucher')) {
          setActiveTab('vouchers')
      }
      else if(value.toLowerCase().includes('invoice')) {
          setActiveTab('invoices')
      }
      else {
          setActiveTab(value)
      }

       
     const data = value === 'failed' ? 
          payload?.filter(trans => trans.status !== 'success') :
          (value !== 'all' ? payload?.filter(trans => trans.transaction_type === value) : payload) 
      setResults(data)
  }

  const handlePagination = (data) => {
      setPayload({...payload, page: data})
      isLoaded.current = false
  }

  const handleInput = (event) => {
      const { name, value } = event.target
      setPayload((prevState)=> ({...prevState,[name]:value}))
  }

  const handleSearch = () => {
      loadTransactions()
  }
  
  const handleShare = async () => {

    try {
      // Convert the receipt to an image
      const dataUrl = await toPng(receiptRef.current);
      const blob = await (await fetch(dataUrl)).blob();

      const file = new File([blob], 'receipt.png', { type: 'image/png' });

      // Use the Web Share API to share the image
      await navigator.share({
        files: [file],
        title: 'Receipt',
        text: 'Here is your receipt',
      });
      // alert('Receipt shared successfully!');
    } catch (error) {
      console.error('Error sharing receipt:', error);
      // alert('Failed to share receipt.');
    }
  };

  const generatePdf = () => {
      const input = document.getElementById('pdf-content');
      
      html2canvas(input).then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF();
          
          // Calculate the width and height to fit the PDF
          const imgWidth = 190; // A4 width in mm
          const pageHeight = pdf.internal.pageSize.height;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          let heightLeft = imgHeight;

          let position = 0;

          // Add the image to the PDF
          pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              pdf.addPage();
              pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
              heightLeft -= pageHeight;
          }
          
          // Save the PDF
          pdf.save(`receipt.pdf`);
      });
  }

  const handleHistoryDownload = () => {
      setPayload((prevState) => ({...prevState, download: 'True'}))
      loadTransactions(true)
  }

    const handleWithdrawal = () => {
        Swal.fire({
            icon: "warning",
            text: "This action will empty your wallet balance. Do you wish to continue?",
            showCancelButton: true,
            showConfirmButton: true,
        })
        .then((result) => {
            if(result.isConfirmed) {
            let requestPayload = {
                pin: payload.pin,
                withdrawal_type: 'all'
            }

            setLoading(true)
            dispatch(withdrawSalesforceBalance(requestPayload))
            .then((response) => {
                if(response.payload?.success === true) {
                setWithdrawal(false)
                Swal.fire({
                    icon: "success",
                    text: response.payload?.message || "Withdrawal successful"
                })
                }
                else {
                Swal.fire({
                    title: "Error",
                    icon: "error",
                    text: response.payload?.message || "An error occured"
                })
                }
            })
            .finally(() => setLoading(false))
            }
        })
    }

  return (
      <Layout>
          <Container className="mt-4 px-4 mb-4">
              <Col md={12} className="d-flex align-items-center justify-content-between no-print">
                <h5>{salesforce?.first_name} Transactions</h5>
                <div>
                    {
                        user?.user_type === 'owner' ?
                        <Button 
                            type="button" 
                            variant="primary" 
                            size="sm"
                            className="me-2"
                            onClick={ () => setWithdrawal(true) }
                        >
                            Sweep Balance
                        </Button> : null
                    }
                    <Button 
                        type="button" 
                        variant="primary" 
                        size="sm"
                        onClick={ () => navigate(user?.user_type === 'owner' ? "/sales-force/agents" : "/members/sales-force/agents")}
                    >Go Back</Button>
                </div>
              </Col>
              {
                  loading ? (
                      <div className="page-loader">
                          <Spinner size="lg" variant="primary"/>
                      </div>
                  ) : null
              }
              <div className="mt-4 no-print">
                  <Row className="data-card mb-3">
                      <Col md={4} sm={12} xs={12} lg={3} className="mb-2">
                          <Card className="border-0 shadow-sm bg--primary">
                              <Card.Body className="d-flex align-items-center gap-3 p-4">
                                  <div className="icon ">
                                      <i className="lni lni-notepad" style={{fontSize: "25px"}}></i>
                                  </div>
                                  <div>
                                      <h5 className="m-0">{formatCurrency(analytics?.all_time_transactions_total).with_currency}</h5>
                                      <p className="m-0">All Time Transactions</p>
                                  </div>
                              </Card.Body>
                          </Card>
                      </Col>
                      <Col md={4} sm={12} xs={12} lg={3} className="mb-2">
                          <Card className="border-0 shadow-sm">
                              <Card.Body className="d-flex align-items-center gap-3 p-4">
                                  <div className="icon bg-light">
                                      <img src={receipt_avatar} alt="receipt" width={25}/>
                                  </div>
                                  <div>
                                      <h5 className="m-0">{formatCurrency(analytics?.today_transactions_total).with_currency}</h5>
                                      <p className="m-0">Transactions Today</p>
                                  </div>
                              </Card.Body>
                          </Card>
                      </Col>
                      <Col md={4} sm={12} xs={12} lg={3} className="mb-2">
                          <Card className="border-0 shadow-sm bg--secondary">
                              <Card.Body className="d-flex align-items-center gap-3 p-4">
                                  <div className="icon">
                                      <FontAwesomeIcon icon="tag" style={{fontSize: "25px"}}/>
                                  </div>
                                  <div>
                                      <h5 className="m-0">{formatCurrency(analytics?.total_transactions_count).formatted}</h5>
                                      <p className="m-0">Total Transactions</p>
                                  </div>
                              </Card.Body>
                          </Card>
                      </Col>
                      <Col md={4} sm={12} xs={12} lg={3} className="mb-2">
                          <Card className="border-0 shadow-sm bg--primary">
                              <Card.Body className="d-flex align-items-center gap-3 p-4">
                                  <div className="icon">
                                      <FontAwesomeIcon icon="sack-dollar" style={{fontSize: "25px"}}/>
                                  </div>
                                  <div>
                                      <h5 className="m-0">{formatCurrency(analytics?.this_month_transactions_total).with_currency}</h5>
                                      <p className="m-0">Transactions this month</p>
                                  </div>
                              </Card.Body>
                          </Card>
                      </Col>
                      <Col md={12} sm={12} className="mt-3">
                            <Card className="border-0 shadow-sm rounded-14">
                                <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
                                    Sales Force Chart
                                    <div>
                                        <div className="input-group">
                                            <Button 
                                                type="button" 
                                                variant="primary text-white" 
                                                onClick={ () => setShowChart(!showChart)}
                                            > { showChart ? (
                                                <>
                                                    Hide &nbsp;
                                                    <FontAwesomeIcon icon={'chevron-up'}/> 
                                                </>
                                            ): (
                                                <>
                                                    Show &nbsp;
                                                    <FontAwesomeIcon icon={'chevron-down'}/> 
                                                </>
                                            )} 
                                            </Button>
                                        </div>
                                    </div>
                                </Card.Header>
                                {
                                    showChart &&
                                    <Card.Body>
                                        <div className="h-100" id="pdf-content">
                                            <TransactionChart 
                                                user_type={ user?.user_type}
                                            />
                                        </div>
                                    </Card.Body>
                                }
                            </Card>
                        </Col>
                  </Row>
                  <RecordFilter
                      handleInput={handleInput}
                      handleSearchSubmit={handleSearch}
                      params={[
                        {label: 'Date', value: 'date'},
                      ]}
                  />
                  <Card className="border-0 shadow-sm">
                      <Card.Header className="bg-primary text-white d-flex justify-content-between">
                          Transaction History
                          <div className="justify-content-end">
                              <Button 
                                  type="button" 
                                  variant="primary text-white" 
                                  onClick={ handleHistoryDownload }
                              > Download <FontAwesomeIcon icon={'cloud-download'}/> 
                              </Button>
                          </div>
                      </Card.Header>
                      <Card.Body className="table-responsive">
                          <Table size="sm" className="table-color table-stripedd w-100">
                              <thead>
                                  <tr>
                                      <th>Details</th>
                                      <th>Date</th>
                                      <th>Reference</th>
                                      <th>Amount</th>
                                      <th>Balance Before</th>
                                      <th>Balance After</th>
                                      <th>Fee</th>
                                      <th>Type</th>
                                      <th></th>
                                  </tr>
                              </thead>
                              <tbody>
                                  {
                                      results?.length ? (
                                          results?.map((item, index) => (
                                              <tr key={index}>
                                                  <td className="m-0 d-flex gap-2 align-items-center" style={{maxWidth: "300px"}}>
                                                      <strong>
                                                          <p className="m-0">
                                                              { shortenText(item.note) || item.transaction_type }
                                                          </p>  
                                                      </strong>
                                                  </td>
                                                  <td style={{fontSize: "13px"}}>{dateFormatter(item.created_at)}</td>
                                                  <td> {item.reference}  </td>
                                                  <td>{formatCurrency(item.amount, item.currency).with_currency}</td>
                                                  <td>{formatCurrency(item.amount_before, item.currency).with_currency} </td>
                                                  <td>{formatCurrency(item.amount_after, item.currency).with_currency} </td>
                                                  <td>{formatCurrency(item.fee, item.currency).with_currency} </td>
                                                  <td>{item.transaction_type}</td>
                                                  <td>
                                                      <div className="d-flex m-0 align-items-center justify-content-between">
                                                          <Dropdown>
                                                            <Dropdown.Toggle variant="light" className="border-0 bg-transparent text-primary" size="sm" id="dropdown-basic">
                                                                <FontAwesomeIcon icon="ellipsis-vertical" style={{fontSize: "20px"}} className="text-muted"/>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                                                <Dropdown.Item 
                                                                    eventKey={1} 
                                                                    className="text-primary d-flex align-items-center gap-1" 
                                                                    onClick={() => selectTransaction(item.reference)}
                                                                >
                                                                <i className="lni lni-eye" style={{fontSize: "20px"}}></i>  View Details
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                          </Dropdown>
                                                      </div>
                                                  </td>
                                              </tr>
                                          ))
                                      )
                                      : 
                                      (
                                          <tr>
                                              <td colSpan={7} className="text-center text-muted">No data found</td>
                                          </tr>
                                      )
                                  }
                              </tbody>
                          </Table>
                      </Card.Body>
                  </Card>
                  {
                      results?.length ? (
                          <div className="table-responsive mt-2">
                              <Paginator
                                  next={paginationData.next} 
                                  prev={paginationData.prev}
                                  setCurrentPage={ handlePagination }
                              />
                          </div>
                      ) : null
                  }
              </div>

              <Modal 
                  show={show_receipt} 
                  fullscreen={true} 
                  onHide={() => setShowReceipt(false)}
                  dialogClassName="receipt-screen-modal"
                  backdrop="static"
                  onClick={stopPropagation}
              >
                  <Modal.Header className="no-print">
                      <div className="w-100 d-flex justify-content-between align-items-center">
                          <button className="btn-plain">
                              <FontAwesomeIcon icon="chevron-left" onClick={ () => setShowReceipt(false) }/>
                          </button>
                          <div>
                              <Button type="button" className="btn-plain bg-primary me-2" onClick={ () => generatePdf() }>
                                  Download <FontAwesomeIcon icon="cloud-download"/>
                              </Button>
                              <Button type="button" className="btn-plain bg-primary me-2" onClick={ () => window.print() }>
                                  Print <FontAwesomeIcon icon="print"/>
                              </Button>
                              <Button type="button" className="btn-plain bg-primary" onClick={ () => handleShare() }>
                                  Share <FontAwesomeIcon icon="share"/>
                              </Button>
                          </div>
                      </div>
                  </Modal.Header>
                  <Modal.Body className="p-2" >
                      <div className="invoice px-3 py-0 border border-0 printarea" id="pdf-content" ref={receiptRef}>
                          <div className="border-bottom border-bottom-1 d-flex align-items-center justify-content-between pb-2 py-2">
                              <Logo variant="dark"/>
                              <div>
                                  <h5 className="mb-0 text-right">Transaction Receipt</h5>
                                  <p className="text-muted text-sm m-0 text-right">Generated: {receipt.date !== null ? dateFormatter(receipt.date) : ''}</p>
                              </div>
                          </div>
                          <div className="table-responsive mb-3">
                              <table className="table border-0">
                                  <tbody>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Transaction Amount
                                          </td>
                                          <td className="border-0 text-right">
                                              {formatCurrency(receipt.amount).with_currency}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Fee
                                          </td>
                                          <td className="border-0 text-right">
                                              {formatCurrency(receipt.fee).with_currency}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Settlement Amount
                                          </td>
                                          <td className="border-0 text-right">
                                              {formatCurrency(receipt.amount - receipt.fee).with_currency}
                                          </td>
                                      </tr>

                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Date
                                          </td>
                                          <td className="border-0 text-right">
                                              {receipt.date !== null ? dateFormatter(receipt.created_at) : ''}
                                          </td>
                                      </tr>

                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Transaction ID
                                          </td>
                                          <td className="border-0 text-right">
                                              {receipt?.reference}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Note
                                          </td>
                                          <td className="border-0 text-right">
                                              {receipt?.note}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </Modal.Body>
              </Modal>

                {/* Withdraw Balance */}
              <Modal 
                  show={withdrawal} 
                  onHide={() => setWithdrawal(false)}
                  backdrop="static"
              >
                    <Modal.Header as="h5" className="d-flex justify-content-between py-2">
                        <strong>Wallet Balance Withdrawal</strong>
                        <button 
                            type="button" 
                            className="btn-plain bg-primary btn-sm rounded text-white"
                            onClick={() => setWithdrawal(false)}
                        >
                            <FontAwesomeIcon icon="close" />
                        </button>
                    </Modal.Header>
                  <Modal.Body className="p-2" >
                    <Row>
                      <FormGroup as={Col} md={12} className="mb-2">
                        <Form.Label>PIN</Form.Label>
                        <Form.Control
                          type="password"
                          required
                          placeholder="Transaction PIN"
                          name="pin"
                          onChange={handleInput}
                        />
                      </FormGroup>
                      <div className="d-grid gap-2 mt-2">
                          <Button
                              type="button" 
                              variant="primary"
                              onClick={handleWithdrawal}
                          >
                              Submit  <Spinner animation={ loading ? "border" : null} role="status" size="sm"></Spinner>
                          </Button>
                      </div>
                    </Row>
                  </Modal.Body>
              </Modal>
          </Container>
      </Layout>
  );
}

export default SalesforceTransactionsHistory;